import React, { useContext, useEffect, useState } from 'react';
import { SearchContext } from './index';
import { Loading } from '../../Loading';
import { useService } from '../../../hooks/useService';
import { randomString } from '../../../helpers/string';
import { formatApiObj } from '../../../helpers/auctions';
import '../../../styles/components/TopContentBlock.less';

const StateTopContentBlock = ({loc}) => {
    const [showMore, setShowMore] = useState(false);
    const {
        searchState: {active_tab, search_obj},
        total_records,
        upcoming_total_records,
        makeApiObj,
    } = useContext(SearchContext);
    const num_auctions = active_tab === 'active' ? total_records : upcoming_total_records;
    const [{ data: {metrics}, loading }, fireGetMetrics] = useService();
    const num_expiring = metrics?.num_expiring;

    useEffect(() => {
        fireGetMetrics({
            url: `/services/reports/auction-metrics/${active_tab}/state/content`,
            params: {
                ...formatApiObj(makeApiObj(search_obj)),
                randStr: randomString(),
            },
        });
    }, []);

    return (
        <div className="top-content-block">
            {loading ? <Loading /> : (
                <>
                    <div style={{maxHeight: showMore ? '' : active_tab === 'active' ? '200px' : '190px', overflow: 'hidden'}}>
                        <p>
                            StorageTreasures is a leading source for finding and winning
                            online storage auctions in {loc}. Find, bid and win abandoned
                            storage units easily from the most complete source of online storage auctions.
                        </p>
                        <p>
                            <strong>Find storage auctions near you, fast</strong><br/>
                            There {num_auctions == 1 ? 'is' : 'are'} currently {num_auctions || 0}{' '}
                            {active_tab} auction{num_auctions == 1 ? '' : 's'} throughout {loc}, based on your filters - no matter where you live, you can always find an auction near you. With StorageTreasures, you can bid and win on {loc} self storage units with ease.
                            {active_tab === 'active' && num_expiring ? ` You will want to act fast, there ${num_expiring == 1 ? 'is' : 'are'} ${num_expiring} auction${num_expiring == 1 ? '' : 's'} in ${loc} ending today.` : ''}
                        </p>
                        <p>
                            <strong>Save time and money</strong><br/>
                            Find incredible deals on all types of items from furniture to{' '}
                            electronics. With our intuitive platform, you can bid on multiple units {' '}
                            with ease and convenience.
                        </p>
                        <p>
                            <strong>
                                Secure and safe bidding process
                            </strong><br/>
                            Our secure bidding process ensures that your data is safe and protected.{' '}
                            We provide detailed information about each unit to help you make an informed{' '}
                            decision before you place a bid.
                        </p>
                        <p>
                            <strong>
                                Unlock the treasures of storage unit auctions by bidding today!
                            </strong>
                        </p>
                    </div>
                    {!showMore && (
                        <p className="read-more" onClick={() => setShowMore(true)}>Read more...</p>
                    )}
                </>
            )}
        </div>
    );
};

StateTopContentBlock.displayName = 'TopContentBlock';

export default StateTopContentBlock;